import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transform',
  standalone: false
})
export class TransformPipe implements PipeTransform {
  transform(value: string, ..._args: any[]): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
